import {
  NumberCell,
  TableBuildingGroupsListCell,
  TableDateCell,
  TableEmptyCell,
  TableFloatCell,
  TableFloorCell,
  TablePropertyShareCell,
  TableTextCell,
  TableUserListCell,
  toTableBuildingGroupsListCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'

import { FlatTableCellName } from './FlatTableRow.constants'

export function renderCell({ item, name, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case FlatTableCellName.Number:
      return <NumberCell {...restProps} value={value} />

    case FlatTableCellName.Building:
      return <TableTextCell {...restProps} value={value?.title} />

    case FlatTableCellName.BuildingGroups:
      return (
        <TableBuildingGroupsListCell
          {...restProps}
          value={value?.map(toTableBuildingGroupsListCell)}
        />
      )

    case FlatTableCellName.Dwellers:
    case FlatTableCellName.Landlords:
      return (
        <TableUserListCell
          {...restProps}
          value={value?.map(toUserMultiValue)}
        />
      )

    case FlatTableCellName.Floor:
      return <TableFloorCell {...restProps} value={value} />

    case FlatTableCellName.Area:
    case FlatTableCellName.LiveArea:
      return <TableFloatCell {...restProps} value={value} />

    case FlatTableCellName.PropertyShare:
      return <TablePropertyShareCell {...restProps} value={value} />

    case FlatTableCellName.Category:
    case FlatTableCellName.Condition:
    case FlatTableCellName.ContractType:
    case FlatTableCellName.FlatSpecifics:
    case FlatTableCellName.RoomType:
      return <TableTextCell {...restProps} value={value?.value} />

    case FlatTableCellName.Created:
    case FlatTableCellName.Updated:
      return <TableDateCell {...restProps} value={value} />

    case FlatTableCellName.Entrance:
    case FlatTableCellName.EntranceAddress:
    case FlatTableCellName.Equipment:
    case FlatTableCellName.HeatType:
    case FlatTableCellName.ORAGCoolingType:
    case FlatTableCellName.ORAGEdvNumber:
    case FlatTableCellName.ORAGFlatEquipment:
    case FlatTableCellName.ORAGFunding:
    case FlatTableCellName.ORAGKeys:
    case FlatTableCellName.ORAGMeterReading:
    case FlatTableCellName.ORAGReasonTermination:
    case FlatTableCellName.ORAGReasonVacancy:
    case FlatTableCellName.ORAGUnitNumber:
    case FlatTableCellName.RentPaymentType:
    case FlatTableCellName.RoomCount:
    case FlatTableCellName.UnitNumber:
      return <TableTextCell {...restProps} value={value} />

    default:
      return <TableEmptyCell {...restProps} />
  }
}
